<script setup lang="ts">
import { useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { store } from '@/routes/projects';

const open = defineModel<boolean>('open', { default: false });

const nameInput = ref<InstanceType<typeof Input> | null>(null);

const form = useForm({
    name: '',
});

function submit() {
    form.post(store.url(), {
        onSuccess: () => {
            form.reset();
            open.value = false;
        },
    });
}

function onOpenChange(value: boolean) {
    open.value = value;

    if (!value) {
        form.reset();
        form.clearErrors();
    }
}
</script>

<template>
    <Dialog :open="open" @update:open="onOpenChange">
        <DialogContent class="sm:max-w-md">
            <DialogHeader>
                <DialogTitle>Nouveau projet</DialogTitle>
                <DialogDescription>
                    Donnez un nom à votre projet de revue de littérature.
                </DialogDescription>
            </DialogHeader>

            <form class="space-y-4" @submit.prevent="submit">
                <div class="space-y-2">
                    <Label for="project-name">
                        Nom du projet
                        <span class="text-rose-500">*</span>
                    </Label>
                    <Input
                        id="project-name"
                        ref="nameInput"
                        v-model="form.name"
                        autofocus
                        placeholder="Ex: Revue systématique sur l'IA en médecine"
                        @keydown.enter.prevent="submit"
                    />
                    <p v-if="form.errors.name" class="text-sm text-rose-600">
                        {{ form.errors.name }}
                    </p>
                </div>

                <DialogFooter>
                    <Button type="button" variant="ghost" @click="open = false">
                        Annuler
                    </Button>
                    <Button
                        type="submit"
                        :disabled="form.processing || !form.name.trim()"
                        class="bg-brand hover:bg-brand/90"
                    >
                        Créer
                    </Button>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>
</template>
